var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "combo-page" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "el-button",
            {
              staticClass: "add-btn",
              attrs: { type: "primary", icon: "el-icon-plus", size: "small" },
              on: { click: _vm.handleShowPopup },
            },
            [_vm._v("新增")]
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              staticClass: "combo-table",
              staticStyle: { "margin-top": "16px" },
              attrs: { data: _vm.tableData, border: "" },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "id", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "productName", label: "套餐名称", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "serviceList",
                  label: "套餐包含服务",
                  "min-width": "220",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          _vm._l(scope.row.serviceList, function (tag, idx) {
                            return _c(
                              "el-tag",
                              {
                                key: idx,
                                staticStyle: {
                                  "margin-right": "4px",
                                  "margin-bottom": "4px",
                                },
                                attrs: { type: "primary", size: "mini" },
                              },
                              [_vm._v(_vm._s(tag))]
                            )
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "price", label: "售价", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "originalPrice", label: "原价", width: "80" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "status", label: "上架状态", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: { "active-value": 1, "inactive-value": -1 },
                          on: {
                            change: function ($event) {
                              return _vm.onlineChange(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "validity", label: "有效期(年)", width: "90" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "tagList", label: "标签", width: "90" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          _vm._l(scope.row.tagList, function (tag, idx) {
                            return _c(
                              "el-tag",
                              {
                                key: idx,
                                staticStyle: {
                                  "margin-right": "4px",
                                  "margin-bottom": "4px",
                                },
                                attrs: { type: "primary", size: "mini" },
                              },
                              [_vm._v(_vm._s(tag))]
                            )
                          }),
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sort", label: "排序", width: "60" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "supplierName", label: "供应商", width: "" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createdUserName",
                  label: "操作人",
                  width: "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "createTime", label: "创建时间", width: "120" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "操作", width: "60" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-link",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.handleEdit(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "pagination-wrap" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.listPram.page,
                  "page-sizes": _vm.listPram.limit,
                  total: _vm.listPram.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "step-dialog",
          attrs: {
            visible: _vm.showDialog,
            width: "90%",
            top: "30px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.showDialog = $event
            },
          },
        },
        [
          _c(
            "el-steps",
            {
              attrs: {
                active: _vm.step,
                "finish-status": "success",
                "align-center": "",
              },
            },
            [
              _c("el-step", {
                attrs: { title: "套餐信息", description: "配置套餐基础信息" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "套餐详情", description: "配置商品详情" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "配置服务", description: "就医服务" },
              }),
              _vm._v(" "),
              _c("el-step", {
                attrs: { title: "其他设置", description: "配置权限" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "step-content" }, [
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === 0,
                    expression: "step === 0",
                  },
                ],
              },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "step-form",
                    attrs: { "label-width": "100px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品名称" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入内容" },
                          model: {
                            value: _vm.form.productName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "productName", $$v)
                            },
                            expression: "form.productName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "售价" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入内容" },
                          model: {
                            value: _vm.form.price,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "price", $$v)
                            },
                            expression: "form.price",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "原价" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入内容" },
                          model: {
                            value: _vm.form.originalPrice,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "originalPrice", $$v)
                            },
                            expression: "form.originalPrice",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "有效期" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "120px" },
                          attrs: { placeholder: "请输入内容" },
                          model: {
                            value: _vm.form.validity,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "validity", $$v)
                            },
                            expression: "form.validity",
                          },
                        }),
                        _vm._v(" "),
                        _c("span", { staticStyle: { "margin-left": "8px" } }, [
                          _vm._v("年"),
                        ]),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "上架状态" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.form.status,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "status", $$v)
                              },
                              expression: "form.status",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: 1 } }, [
                              _vm._v("上架"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: 2 } }, [
                              _vm._v("下架"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("el-form-item", { attrs: { label: "商品主图" } }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            display: "flex",
                            "align-items": "center",
                          },
                        },
                        [
                          _vm._l(_vm.form.imageList, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticStyle: { "margin-right": "20px" },
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "70px",
                                    height: "70px",
                                    "margin-right": "20px",
                                  },
                                  attrs: { src: item },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      position: "relative",
                                      right: "10px",
                                      top: "-65px",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDelete(index)
                                      },
                                    },
                                  },
                                  [_vm._v("X")]
                                ),
                              ]
                            )
                          }),
                          _vm._v(" "),
                          _c(
                            "el-upload",
                            {
                              staticClass: "upload-demo",
                              attrs: {
                                action: "",
                                "http-request": _vm.handleUploadFormNew,
                                headers: _vm.myHeaders,
                                "show-file-list": false,
                                multiple: "",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  staticClass: "mr10",
                                  attrs: { type: "primary" },
                                },
                                [_vm._v("上传图片")]
                              ),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "供应商" } },
                      [
                        _c(
                          "el-select",
                          {
                            staticClass: "selWidth ",
                            attrs: { clearable: "", placeholder: "请选择" },
                            model: {
                              value: _vm.form.supplierId,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "supplierId", $$v)
                              },
                              expression: "form.supplierId",
                            },
                          },
                          _vm._l(_vm.formStoreSelect, function (item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: {
                                label: item.supplierName,
                                value: item.id,
                              },
                            })
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "标签" } },
                      [
                        _vm._l(_vm.form.tagList, function (tag) {
                          return _c(
                            "el-tag",
                            {
                              key: tag,
                              staticStyle: { "margin-right": "4px" },
                              attrs: { closable: "" },
                              on: {
                                close: function ($event) {
                                  return _vm.removeTag(tag)
                                },
                              },
                            },
                            [_vm._v(_vm._s(tag))]
                          )
                        }),
                        _vm._v(" "),
                        _vm.inputVisible
                          ? _c("el-input", {
                              staticClass: "input-new-tag",
                              staticStyle: { width: "100px" },
                              attrs: { size: "mini" },
                              on: { blur: _vm.addTag },
                              nativeOn: {
                                keyup: function ($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  ) {
                                    return null
                                  }
                                  return _vm.addTag($event)
                                },
                              },
                              model: {
                                value: _vm.inputValue,
                                callback: function ($$v) {
                                  _vm.inputValue = $$v
                                },
                                expression: "inputValue",
                              },
                            })
                          : _c(
                              "el-button",
                              {
                                staticClass: "button-new-tag",
                                attrs: { size: "mini" },
                                on: {
                                  click: function ($event) {
                                    _vm.inputVisible = true
                                  },
                                },
                              },
                              [_vm._v("+ 新建标签")]
                            ),
                      ],
                      2
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "排序" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入内容" },
                          model: {
                            value: _vm.form.sort,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "sort", $$v)
                            },
                            expression: "form.sort",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "备注" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "请输入内容" },
                          model: {
                            value: _vm.form.remark,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "remark", $$v)
                            },
                            expression: "form.remark",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === 1,
                    expression: "step === 1",
                  },
                ],
              },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "step-form",
                    attrs: { "label-width": "100px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "商品详情" } },
                      [
                        _c("Tinymce", {
                          ref: "tinymceEditor",
                          model: {
                            value: _vm.form.description,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "description", $$v)
                            },
                            expression: "form.description",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === 2,
                    expression: "step === 2",
                  },
                ],
              },
              [
                _c(
                  "el-table",
                  { attrs: { data: _vm.serviceTable, border: "" } },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "serviceName",
                        width: "500",
                        label: "就医服务",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "使用次数", width: "500" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("el-input-number", {
                                attrs: { min: 1, size: "small" },
                                model: {
                                  value: scope.row.usageCount,
                                  callback: function ($$v) {
                                    _vm.$set(scope.row, "usageCount", $$v)
                                  },
                                  expression: "scope.row.usageCount",
                                },
                              }),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "图标", width: "200" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleUpImg(scope.row)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "el-upload",
                                    {
                                      staticClass: "upload-demo",
                                      attrs: {
                                        action: "",
                                        "http-request": _vm.handleUploadForm,
                                        headers: _vm.myHeaders,
                                        "show-file-list": false,
                                        multiple: "",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        staticStyle: {
                                          width: "70px",
                                          height: "70px",
                                        },
                                        attrs: { src: scope.row.serviceIcon },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "el-button",
                                        {
                                          staticClass: "mr10",
                                          attrs: { type: "primary" },
                                        },
                                        [_vm._v("上传图片")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.step === 3,
                    expression: "step === 3",
                  },
                ],
              },
              [
                _c(
                  "el-form",
                  {
                    staticClass: "step-form",
                    attrs: { "label-width": "120px" },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "同步分销授权:" } },
                      [
                        _c(
                          "el-checkbox-group",
                          {
                            on: { change: _vm.handleCheckedCitiesChange },
                            model: {
                              value: _vm.form.customerIdList,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "customerIdList", $$v)
                              },
                              expression: "form.customerIdList",
                            },
                          },
                          _vm._l(_vm.authList, function (item) {
                            return _c(
                              "el-checkbox",
                              { key: item.id, attrs: { label: item.id } },
                              [_vm._v(_vm._s(item.name))]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "step-footer" },
            [
              _vm.step > 0
                ? _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.step--
                        },
                      },
                    },
                    [_vm._v("上一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.step < 3
                ? _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          _vm.step++
                        },
                      },
                    },
                    [_vm._v("下一步")]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.submit } },
                [_vm._v(_vm._s(_vm.typeEdit ? "提交" : "更改"))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }